import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BoxSuggestionComponent } from './components/box-suggestion/box-suggestion.component';
import { MoreActionComponent } from './components/more-action/more-action.component';
import { TaskCardComponent } from './components/task-card/task-card.component';
import { SwitchBoxComponent } from './components/switch-box/switch-box.component';
import { FormsModule } from '@angular/forms';
import { DetailsCanvasComponent } from './components/details-canvas/details-canvas.component';
import { UpdateItemAttritubesComponent } from './components/update-item-attritubes/update-item-attritubes.component';
import { EnumLabelPipe } from "../../pipes/enum-label.pipe";
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [BoxSuggestionComponent,MoreActionComponent,TaskCardComponent,SwitchBoxComponent,DetailsCanvasComponent,UpdateItemAttritubesComponent],
  imports: [CommonModule, FormsModule, EnumLabelPipe, NgSelectModule],
  exports: [BoxSuggestionComponent,MoreActionComponent,TaskCardComponent,SwitchBoxComponent,DetailsCanvasComponent,UpdateItemAttritubesComponent],
})
export class OutboundModule {}